import { useLocalStorage } from "react-use";
import { LOCAL_STORAGE_SIMULATION_FORM_KEY } from "../../../core/service/BusinessLogicService";

export default function useLocalStorageSimulationForm () {
  const [getLocalStorageSimulationForm, setLocalStorageSimulationForm, remove] = useLocalStorage(
    LOCAL_STORAGE_SIMULATION_FORM_KEY,
    {
      serializer: (value) => JSON.stringify(value),
      deserializer: (value) => JSON.parse(value)
    }
  )

  return {
    getLocalStorageSimulationForm,
    setLocalStorageSimulationForm,
    remove
  }
}
